import { useOutletContext } from 'react-router-dom'

import { type PlanningPeriodDetailQuery } from 'generated/resources/graphql'

import { HeadcountEmployeeSheet } from 'modules/planning/components/Headcount/EmployeeSheet'

type PeriodDetailContext = {
  period: PlanningPeriodDetailQuery['planning']['period']
  periodId: string
}

const PeriodEmployeeSheetTab = () => {
  const { periodId } = useOutletContext<PeriodDetailContext>()

  return <HeadcountEmployeeSheet periodId={periodId} />
}

export default PeriodEmployeeSheetTab
